import { DndContext } from '@dnd-kit/core'
import { arrayMove, SortableContext } from '@dnd-kit/sortable'
import { useQueryClient } from '@tanstack/react-query'
import AccordionItem from 'components/Elements/StyledAccordionItem'
import { useEffect, useState } from 'react'
import { Accordion } from 'react-bootstrap'
import axiosClient from 'services/axios-client'
import { useBookRoleQuery } from 'store/queries'
import { AnswersContainer } from '../style'
import AnswerItem from './components/AnswerItem'

function Answers({
  answers,
  question = {},
  bookDetail = {},
  onViewImages,
  onViewAnswer,
  onEditAnswer,
  selectedToggle,
  setSelectedToggle,
}) {
  const queryClient = useQueryClient()
  const { data: role } = useBookRoleQuery(bookDetail.id)
  const [localAnswers, setLocalAnswers] = useState([])
  // We need a local copy to make drag and drop work.
  // Possibly switch tu using rq with a memoized selector?
  useEffect(() => {
    setLocalAnswers(answers)
  }, [answers])

  const handleSaveAnswerOrder = async (orderedAnswers) => {
    const { ok } = await axiosClient.post(
      `/book/${bookDetail.id}/question/${question.book_question_join_id}/answer-order`,
      {
        sort_data: orderedAnswers,
      },
    )

    if (ok) {
      queryClient.invalidateQueries({
        queryKey: ['book', bookDetail.id, 'questions'],
      })
    }
  }

  // TODO: We have enough of these that it should probably be extracted into a component.
  const onSortAnswers = (e) => {
    const { active, over } = e

    if (active?.id !== over?.id) {
      const oldIndex = localAnswers.findIndex((p) => p.id === active.id)
      const newIndex = localAnswers.findIndex((p) => p.id === over.id)
      const newAnswers = arrayMove(localAnswers, oldIndex, newIndex)

      newAnswers.forEach((p, i) => {
        p.sort = i
      })

      setLocalAnswers(newAnswers)
      handleSaveAnswerOrder(newAnswers)
    }
  }

  const isPurchaserOrEditor =
    role?.name === 'Purchaser' || role?.name === 'Editor'

  return (
    <>
      <AnswersContainer>
        <DndContext onDragEnd={onSortAnswers}>
          {/* !! Neccessary as bools are encoded as numbers and SortableContext sensibly expects an actual bool */}
          <SortableContext
            items={localAnswers.map((q) => q.id)}
            disabled={!isPurchaserOrEditor || !!bookDetail.is_published}
          >
            <Accordion>
              {localAnswers.map((_answer, _i) => {
                if (
                  isPurchaserOrEditor ||
                  _answer.user_id === role?.user_id ||
                  question.is_sent
                ) {
                  return (
                    <AccordionItem
                      className={
                        role?.name === 'Author' &&
                        _answer.user_id !== role?.user_id &&
                        (question?.answers?.length > 0 &&
                          question?.answers?.find(
                            (a) => a.is_submitted === 0,
                          ) === undefined) === false
                          ? 'accordion-item-hide'
                          : ''
                      }
                      key={_i}
                      eventKey={`answerpart${_i}`}
                      selectedToggle={selectedToggle}
                      setSelectedToggle={setSelectedToggle}
                      renderToggle={() => (
                        <AnswerItem
                          isPublished={bookDetail.is_published}
                          answer={_answer}
                          isSubmitted={
                            question?.answers?.length > 0 &&
                            question?.answers?.find(
                              (a) => a.is_submitted === 0,
                            ) === undefined
                          }
                          role={role?.name}
                          isOwn={_answer.user_id === role?.user_id}
                          onEditAnswer={(e, answer) => {
                            e.preventDefault()
                            e.stopPropagation()
                            e.nativeEvent.stopImmediatePropagation()
                            onEditAnswer(question, answer)
                          }}
                          onViewImages={(e, answer) => onViewImages(e, answer)}
                          onViewAnswer={(e, answer) => {
                            e.preventDefault()
                            e.stopPropagation()
                            e.nativeEvent.stopImmediatePropagation()
                            onViewAnswer(question, answer)
                          }}
                        />
                      )}
                      renderWhenExpanded={() => {
                        return <></>
                      }}
                    />
                  )
                } else {
                  return <div key={_i} />
                }
              })}
            </Accordion>
          </SortableContext>
        </DndContext>
      </AnswersContainer>
    </>
  )
}

export default Answers
